import { YandexMetrikaAbTestModule } from '@analytics/feature';
import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SdvorItemCounterModule } from '@sdvor/product/ui';
import {
  CustomStarRatingComponent,
  SdvorButtonComponent,
  SdvorNavigationArrowComponent,
  UrlMediaPipe,
} from '@sdvor/shared/ui';
import { BonusWidgetComponent } from '@sdvor/shared/ui/v2';
import { FeaturesConfigModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule, PromotionsModule, SpinnerComponent } from '@spartacus/storefront';
import { OrderDownloadBillComponent, OrderStatusLabelComponent } from '../../components';
import { SdCustomOrderDetailActionsComponent } from './order-detail-actions/order-detail-actions.component';
import { SdCustomOrderConsignedEntriesComponent } from './order-detail-items/order-consigned-entries/order-consigned-entries.component';
import { OrderDeliveryFilterComponent } from './order-detail-items/order-delivery-filter/order-delivery-filter.component';
import { SdCustomOrderDetailItemsComponent } from './order-detail-items/order-detail-items.component';
import { SdCustomOrderItemListComponent } from './order-detail-items/order-item-list/order-item-list.component';
import { SdCustomOrderItemComponent } from './order-detail-items/order-item/order-item.component';
import { OrderSummaryBonusComponent } from './order-detail-items/order-summary-bonus/order-summary-bonus.component';
import { SdOrderDetailPickupSchemeComponent } from './order-detail-pickup-scheme';
import { SdCustomOrderDetailShippingComponent } from './order-detail-shipping/order-detail-shipping.component';
import { SdCustomOrderDetailTotalsComponent } from './order-detail-totals/order-detail-totals.component';
import { SdCustomOrderSummaryComponent } from './order-detail-totals/order-summary/order-summary.component';
import { SdOrderRepeatButtonComponent } from './order-repeat-button/order-repeat-button.component';

const moduleComponents = [
  SdCustomOrderDetailActionsComponent,
  SdCustomOrderDetailItemsComponent,
  SdCustomOrderDetailTotalsComponent,
  SdCustomOrderDetailShippingComponent,
  SdCustomOrderConsignedEntriesComponent,
  SdCustomOrderSummaryComponent,
  SdCustomOrderItemListComponent,
  SdCustomOrderItemComponent,
  SdOrderDetailPickupSchemeComponent,
  SdOrderRepeatButtonComponent,
  OrderSummaryBonusComponent,
  OrderDeliveryFilterComponent,
];

@NgModule({
  imports: [
    NgIf,
    NgFor,
    NgClass,
    AsyncPipe,
    RouterLink,
    ReactiveFormsModule,
    MediaModule,
    UrlMediaPipe,
    DatePipe,
    SdvorItemCounterModule,
    IconModule,
    FeaturesConfigModule,
    PromotionsModule,
    UrlModule,
    OrderStatusLabelComponent,
    SpinnerComponent,
    SdvorNavigationArrowComponent,
    OrderDownloadBillComponent,
    SdvorButtonComponent,
    CustomStarRatingComponent,
    YandexMetrikaAbTestModule,
    BonusWidgetComponent,
  ],
  declarations: [...moduleComponents],
  exports: [...moduleComponents],
})
export class OrderDetailsModule {}
